export const getUserName = (firstName: string, lastName: string, email: string): string => {
  return firstName || lastName ? `${lastName}, ${firstName}` : email;
}
